import type { GADataProps } from "@elements/GAData/GAData";
import type { MetaTagsProps } from "@elements/MetaTags/MetaTags";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export default function GeneralElectionsMetaData(
  section: string,
): PageMetaDataValues {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: "Budget 2026",
    startDate: "2026-02-11T13:00:00+08:00",
    location: {
      "@type": "Place",
      name: "Singapore",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Singapore",
      },
    },
    description: "Budget 2026 coverage and updates.",
  };
  const metaTags: MetaTagsProps = {
    title: "Budget 2026: Berita & Perkembangan Terkini | Beritaharian.sg",
    description:
      "Dapatkan berita, video, dan analisis mendalam terkini mengenai Budget 2026. Ikuti perkembangan terbaru secara langsung dari Beritaharian.sg.",
    slug: section,
    keywords: ["Budget 2026"],
    jsonLd,
  };

  const gaData: GADataProps = {
    level2: section,
    title: "Budget_2026_Index",
    section: section,
    contentcat: "1",
    contenttype: "listing",
  };

  return {
    gaData,
    metaTags,
  };
}
